import { render, staticRenderFns } from "./InvPF_Sign.vue?vue&type=template&id=0ef9c83b"
import script from "./InvPF_Sign.vue?vue&type=script&lang=js"
export * from "./InvPF_Sign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports